import { defineComponent as _defineComponent } from 'vue'
import {VPopover} from "@/components/v-tooltip";
import {PopoverTooltipPlacement} from "@/typings/PopoverTooltipPlacement";

type vTooltipProps = {
  tooltipPlacement: PopoverTooltipPlacement;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'vTooltip',
  props: {
    tooltipPlacement: { default: "top-end" }
  },
  setup(__props: any) {

const props = __props as { tooltipPlacement: PopoverTooltipPlacement };



return { __sfc: true,props, VPopover }
}

})